import React from 'react'

const AboutUs = () => {
  return (
    <div className='about-container'>
      <h1>About Us Page</h1>
    </div>
  )
}

export default AboutUs

